module.exports = __webpack_public_path__ + "img/recordEmpty.60e7f5ca.png";